<template>
  <!-- 出口 -->
  <div>
    <div class="delivery-show meijiadaomen">
      <div class="delivery-main delivery-main-1">
        <div class="delivery-main-box">
          <img src="@/assets/images/国家.png" alt="" />
          <div class="address">
            <div>国家</div>
            <el-select
              @change="getPortList"
              v-model="mjdmForm.country_id"
              clearable
              filterable
              placeholder="请选择国家"
            >
              <el-option
                v-for="item in countryList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <!-- <div class="delivery-main-box">
          <img src="@/assets/images/定位.png" alt="" />
          <div class="address">
            <div>起运港</div>
            <el-select
              v-model="mjdmForm.state_port_id"
              clearable
              filterable
              placeholder="请选择"
            >
              <el-option
                v-for="item in statePortList"
                :key="item.id"
                :label="item.port + '-' + item.port_english"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
        </div> -->
        <!-- <div class="delivery-main-box">
          <img src="@/assets/images/箱型.png" alt="" />
          <div class="address">
            <div>箱型</div>
            <el-select
              :multiple-limit="1"
              class="xiangxing"
              clearable
              collapse-tags
              v-model="mjdmForm.cases_gauge_type_id"
              placeholder="请选择"
            >
              <el-option
                v-for="item in boxTypeList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
        </div> -->
        <div class="delivery-main-box">
          <img src="@/assets/images/城市.png" alt="" />
          <div class="address">
            <div>送达城市(邮编)</div>
            <el-select
              @change="getfujinPort"
              v-model="mjdmForm.end_city_id"
              clearable
              filterable
              placeholder="请输入送达城市(邮编)"
              remote
              reserve-keyword
              :remote-method="zipCodeRemoteMethod"
              :loading="loading"
            >
              <el-option
                v-for="item in endPortList"
                :key="item.id"
                :label="item.place_name + '(' + item.postal_code + ')'"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="delivery-main-box">
          <img src="@/assets/images/定位.png" alt="" />
          <div class="address">
            <div>卸货港/卸货地</div>
            <el-select
              v-model="mjdmForm.port_id"
              clearable
              filterable
              placeholder="请选择"
            >
              <el-option
                v-for="item in portList"
                :key="item.id"
                :label="item.port"
                :value="item.id"
              >
              </el-option>
              <div>
                <el-button v-show="chakanShow" class="chakan" type="text" @click="getChakan">查看更多</el-button>
              </div>
            </el-select>
          </div>
        </div>
        <!-- <div class="delivery-main-box">
            
        </div> -->
        <div class="huoquyj">
            <el-button type="primary" @click="getFreightRates">获取运价</el-button>
        </div>
      </div>
      
    </div>

    <div class="jieguo" v-show="result">
      <!-- 收费标准 -->
      <div class="tit">收费标准</div>
      <div class="role" v-html="fee_standards"></div>
      <div class="foot">
        <div class="heji">拖车费合计：<span>${{fee}}</span></div>
        <div class="butt">
          <!-- <el-button icon="el-icon-user" class="zixun">我要咨询</el-button> -->
          <el-button class="zixun" @click="onlineMessage">在线留言</el-button>
          <el-button class="zixun" @click="showKefu">联系客服</el-button>
          <el-button
            class="xiadan"
            @click="placeAnOrder"
            >我要下单</el-button
          >
        </div>
      </div>
    </div>

    <!-- 留言弹窗 -->
    <el-dialog title="在线留言" :visible.sync="dialogLiuyan" class="ddDialog">
        <span slot="title" class="dialog-title">在线留言</span>
        <div class="dd-con">
            <div class="dd-con-yi txhz">
                <div class="dd-con-yi-width dd-con-er-width">
                    <div class="dd-con-tit"><span>*</span>国家</div>
                    <el-select
                      disabled
                      v-model="onlineForm.country_id"
                      clearable
                      filterable
                      placeholder="请选择国家"
                    >
                      <el-option
                        v-for="item in countryList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                </div>
                <div class="dd-con-yi-width dd-con-er-width">
                    <div class="dd-con-tit"><span>*</span>起运城市(邮编)</div>
                    <el-select
                      disabled
                      v-model="onlineForm.end_city_id"
                      clearable
                      filterable
                      placeholder="请输入起运城市(邮编)"
                      remote
                      reserve-keyword
                      :remote-method="zipCodeRemoteMethod"
                      :loading="loading"
                    >
                      <el-option
                        v-for="item in endPortList"
                        :key="item.id"
                        :label="item.place_name + '(' + item.postal_code + ')'"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                </div>
                <div class="dd-con-yi-width dd-con-er-width">
                    <div class="dd-con-tit"><span>*</span>卸货港、卸货地 | 装货港、装货地</div>
                    <el-select
                      disabled
                      v-model="onlineForm.port_id"
                      clearable
                      filterable
                      placeholder="请选择装货港/装货地"
                    >
                      <el-option
                        v-for="item in portList"
                        :key="item.id"
                        :label="item.port"
                        :value="item.id"
                      >
                      </el-option>
                      <div>
                        <el-button v-show="chakanShow" class="chakan" type="text" @click="getChakan">查看更多</el-button>
                      </div>
                    </el-select>
                </div>
            </div>
            <div class="dd-con-yi txhz">
                <div class="dd-con-yi-width">
                    <div class="dd-con-tit"><span>*</span>姓名</div>
                    <el-input v-model="onlineForm.nickname" placeholder=""></el-input>
                </div>
                <div class="dd-con-yi-width">
                    <div class="dd-con-tit"><span>*</span>电子邮箱</div>
                    <el-input v-model="onlineForm.email" placeholder=""></el-input>
                </div>
            </div>
            <div class="dd-con-er">
                <div class="dd-con-tit"><span>*</span>留言内容</div>
                <el-input
                    type="textarea"
                    :rows="2"
                    placeholder=""
                    v-model="onlineForm.content">
                </el-input>
            </div>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogLiuyan = false" class="quxiao">取消</el-button>
            <el-button type="primary" @click="submitMessage" class="queding">发送</el-button>
        </div>
    </el-dialog>

    <!-- 客服信息弹窗 -->
    <el-dialog class="appdialog" :visible.sync="dialogVisible" :show-close="false" v-draggable>
        <span slot="title" class="dialog-title">
          <div class="applan"><div class="appfen"></div></div>
        </span>

        <div class="dingwei">
            <i class="el-icon-close" @click="dialogVisible=false"></i>
            <div class="dizhi">
                <img class="kflogoIng" src="@/assets/images/hpcopy/logo.png" alt="">
                <div>
                    <!-- <div class="dx-tit">订好舱</div>
                    <div class="dz-wprd">
                        (<span>WCA ID</span>: 135278; <span>WIFFA ID</span>: W0010169)
                    </div> -->
                </div>
            </div>
            <div class="dhk-xia">
                <div class="xia-left">
                    <div class="txDingwei">
                        <img v-if="kefuForm.avatar!=''" class="touxImg" :src="kefuForm.avatar" alt="">
                        <div class="zanwu" v-else>暂无图片</div>
                        <img v-if="kefuForm.avatar!=''" @click="dialogVisibleImg = true" class="delImg" src="@/assets/home/da.png" alt="">
                    </div>
                    <div>
                        <div class="txname">{{kefuForm.nickname}}</div>
                        <div>{{kefuForm.jobs_name}}</div>
                        <div class="neior">青岛市市北区徐州路160号宇恒大厦702室</div>
                        <div class="wangzhi">
                            <img class="img" src="@/assets/home/diqiu.png" alt="">
                            <!-- <a href="https://serve.fulltranslgst.com/" target="_blank">www.fulltranslgst.com</a> -->
                            <a href="https://www.dhcang.com" target="_blank">https://www.dhcang.com</a>
                        </div>
                    </div>
                </div>
                <div class="xia-line"></div>
                <div class="xia-right">
                    <div class="tx-xx">
                        <img class="tx-img" src="@/assets/home/email.png" alt="">
                        <div class="youxiang txhz">
                            <span class="span">邮箱：</span>
                            <span  @click="dialogEmail = true">{{kefuForm.address}}</span>
                            <img  @click="dialogEmail = true" class="clickImg" src="@/assets/home/click.png" alt="">
                            <img  v-if="kefuForm.address" @click="getCopy(kefuForm.address)" class="copyimg" src="@/assets/home/copy.png" alt="">
                        </div>
                    </div>
                    <div class="tx-xx">
                        <img class="tx-img" src="@/assets/home/shouji.png" alt="">
                        <div class="txhz">
                            <span class="span">电话：</span>
                            <span>{{kefuForm.phone}}</span>
                            <img  v-if="kefuForm.phone" @click="getCopy(kefuForm.phone)" class="copyimg" src="@/assets/home/copy.png" alt="">
                        </div>
                    </div>
                    <div class="tx-xx">
                        <img class="tx-img" src="@/assets/home/wx.png" alt="">
                        <div class="txhz">
                            <span class="span">微信：</span>
                            <span>{{kefuForm.wechat}}</span>
                            <img  v-if="kefuForm.wechat" @click="getCopy(kefuForm.wechat)" class="copyimg" src="@/assets/home/copy.png" alt="">
                        </div>
                    </div>
                    <div class="tx-xx">
                        <img class="tx-img" src="@/assets/home/dianhua.png" alt="">
                        <div class="txhz">
                            <span class="span">QQ：</span>
                            <span>{{kefuForm.qq}}</span>
                            <img  v-if="kefuForm.qq" @click="getCopy(kefuForm.qq)" class="copyimg" src="@/assets/home/copy.png" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </el-dialog>

      <!-- 预览图片 -->
    <el-dialog :visible.sync="dialogVisibleImg"  width="30%">
        <img width="100%" :src="kefuForm.avatar" alt="">
    </el-dialog>

      <!-- 邮箱弹窗 -->
      <el-dialog title="发送邮件" :visible.sync="dialogEmail" class="emailDialog">
        <span slot="title" class="dialog-title">发送邮件</span>
        <div class="dd-con">
            <div class="dd-con-yi">
                <div class="dd-con-tit"><span>*</span>收件人</div>
                <el-input readonly v-model="emailForm.email" placeholder=""></el-input>
            </div>
            <div class="dd-con-yi">
                <div class="dd-con-tit">抄送人</div>
                <el-tag
                :key="tag"
                v-for="tag in emailForm.cc_to"
                closable
                :disable-transitions="false"
                @close="handleClose(tag)">
                {{tag}}
                </el-tag>

                <el-input
                class="input-new-tag"
                v-if="inputVisible"
                v-model="inputValue"
                ref="saveTagInput"
                size="small"
                @keyup.enter.native="handleInputConfirm"
                @blur="handleInputConfirm"
                >
                </el-input>

                <el-button v-if="!inputVisible && emailForm.cc_to.length<10" class="button-new-tag" size="small" @click="showInput">+ 新增抄送人</el-button>
            </div>
            <div class="dd-con-er">
                <div class="dd-con-tit"><span>*</span>内容</div>
                <el-input
                    type="textarea"
                    :rows="2"
                    placeholder=""
                    v-model="emailForm.content">
                </el-input>
            </div>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogEmail = false" class="quxiao">取消</el-button>
            <el-button type="primary" @click="submitEmail" class="queding">发送</el-button>
        </div>
    </el-dialog>
    <!-- <div class="info">
            <Map :parent-object="parentObject" class="map" />
            <div class="xinxi">
                <div class="tit">
                    查询信息
                </div>
                <div class="comn">
                    <div><span>卸货港：</span>{{dischargingPort}}</div>
                    <div><span>目的地：</span>{{dischargePlace}}</div>
                    <div><span>总里程：</span>{{mileage}}</div>
                </div>
            </div>
        </div> -->
  </div>
</template>
    
<script>
// import Map from "./MapPage.vue";
import {
  baseCasesGaugeTypeValidList,
  // getPortByCountries,
  getCityList,
  getPortByCityId,
  MjdmOnlineInquiryRecordsAdd,
  mjdmReplyAdd,
  sendEmail,
} from "@/api/api";
export default {
    props:{
        parMessage: {
            type: Object,
            required: true
        },
    },
  components: {
    // Map
  },
  data() {
    return {
      mjdmForm: {
        type: "1", // 进出口：1出口、2进口
        country_id: 6, // 国家id
        // state_port_id: "", // 起运港ID | 卸货港ID
        end_city_id: "", // 送达城市ID | 起运城市ID
        port_id: "", // 卸货港、卸货地ID | 装货港、装货地ID
        // cases_gauge_type_id: "", //箱规ID
      },
      countryList: [
        {
          "id": 6,
          "name": "美国"
        },
        {
          "id": 7,
          "name": "加拿大"
        }
      ],
      statePortList: [], //美加到门起运港
      endPortList: [], // 美加到门送达城市
      portList: [], // 美加到门卸货港卸货地
      boxTypeList: [],
      loading: false,
      // 查询  收费标准展示
      result: false,
      parentObject: {
        state_lon: "",
        state_lat: "",
        end_lon: "",
        end_lat: "",
      },

      // 卸货港
      dischargingPort: "--",
      // 卸货地
      dischargePlace: "--",
      // 里程
      mileage: "--",
      message: {},
      headers:{
        token: localStorage.getItem('token')
      },
      // 拖车费
      fee_standards:'',
      fee:'',
      // 我要下单， 跳转页面带走的参数
      canshu:{},
      chakanShow:true,

      isSubmitting:false,
      // 在线留言
      dialogLiuyan:false,
      onlineForm:{
        kefu_id:'',
        type:'1',
        country_id:'',
        end_city_id:'',
        port_id:'',
        nickname:'',
        email:'',
        content:'',
      },

      dialogVisible:false,
      dialogVisibleImg:false,
      kefuForm:{},
      dialogEmail:false,
      inputVisible: false,
      inputValue: '',
      emailForm:{
          type:3,
          cc_to:[],
          email:'',
          kefu_id:'',
          content:'',
          shippingSpace:{},
          mjdmInfo:{
            type:'--',
            country_name:'--',
            state_area_name:'--',
            state_area_code:'--',
            end_port_name:'--',
            distance:'--',
            price:'--',
          }
      },
    };
  },
  methods: {
    // 复制
    getCopy(e){
      if (navigator.clipboard && window.isSecureContext) {
        this.$message.success('复制成功')
        return navigator.clipboard.writeText(e)
      } else {
        const textarea = document.createElement('textarea');
        textarea.value = e
        document.body.appendChild(textarea);
        textarea.select();
        const successful = document.execCommand('copy');
        if(successful){
          this.$message.success('复制成功')
          textarea.remove()
        }else{
          this.$message.success('复制失败')
          textarea.remove()
        }
      }
    },
    handleClose(tag) {
        this.emailForm.cc_to.splice(this.emailForm.cc_to.indexOf(tag), 1);
    },
    showInput() {
        this.inputVisible = true;
        this.$nextTick(() => {
            this.$refs.saveTagInput.$refs.input.focus();
        });
    },
    handleInputConfirm() {
        let inputValue = this.inputValue;
        if (inputValue) {
            // 判断验证是否通过
            if (!this.validFn(inputValue)) {
                return;
            }

            if(this.emailForm.cc_to.length<=9){
                this.emailForm.cc_to.push(inputValue);
            }else{
                this.$message({
                    type:'error',
                    message:'最多添加十个抄送人'
                })
            }
        }
        this.inputVisible = false;
        this.inputValue = '';
    },
    async submitEmail(){
        try {
            if (this.isSubmitting) return;  // 防止连点操作  
    
            this.isSubmitting = true;

            const res = await sendEmail(this.emailForm,this.headers)
            if(res.code==1){
                this.isSubmitting = false

                this.$message({
                    type:"success",
                    message:'发送成功'
                })
                this.dialogEmail = false
                this.dialogVisible = false
                this.emailForm = {
                    type:3,
                    kefu_id:'',
                    email:'',
                    content:'',
                    cc_to:[],
                    shippingSpace:{},
                    mjdmInfo:{
                      type:'--',
                      country_name:'--',
                      state_area_name:'--',
                      state_area_code:'--',
                      end_port_name:'--',
                      distance:'--',
                      price:'--',
                    }
                }
            }else{
                this.isSubmitting = false

                this.$message({
                    type:"error",
                    message:res.msg
                })
            }
        } catch (error) {
            console.log(error,'error');
        }
    },
    // 起运港
    handleCommandMJDM(command) {
      this.searchQuery1MJDM = command;
    },
    // 目的港
    handleCommand2MJDM(command) {
      this.searchQuery2MJDM = command;
    },
    // 箱型
    handleCommand3MJDM(command) {
      let ind = this.searchQuery3MJDM.findIndex((item) => {
        return item == command;
      });
      if (ind == -1) {
        this.searchQuery3MJDM.push(command);
      } else {
        this.searchQuery3MJDM.splice(ind, 1);
      }
    },
    // 国家
    countryHandleCommand(command) {
      this.countryText = command;
    },
    // 邮编
    zipCodeHandleCommand(command) {
      this.zipCodeText = command;
    },
    async getBoxTypeList() {
      const res = await baseCasesGaugeTypeValidList();
      if (res.code == 1) {
        this.boxTypeList = res.data;
      }
    },
    // 美加到门  起运港
    async getPortList() {
      //   let cou_id =  this.mjdmForm.country_id
      //   if(e!=undefined){
      //       cou_id = e
      //   }
      // let params = {
      //   page_no: 1,
      //   page_size: 10,
      //   countries_id: cou_id,
      // };
      // const res = await getPortByCountries(params);
      // if (res.code == 1) {
      //   this.statePortList = res.data.lists;
        this.mjdmForm.end_city_id = ''
        this.mjdmForm.port_id = ''
        this.zipCodeRemoteMethod()
        this.portList=[]
      // }

      this.message = {
        parentObject:{
          state_lon:'', // 开始地点纬度
          state_lat:'',  //开始地点经度
          end_lon:'',  //结束地点纬度
          end_lat:'',  //结束地点经度
          select:this.mjdmForm.country_id,  //国家
        },
        distance:'--',  //距离，单位英里
        state_area_name:'--',  //开始地点名称
        end_port_name:'--'  //结束地点名称
      }
      this.$emit("from-child", this.message);
    },
    // statePortList:[], //美加到门起运港
    // endPortList:[], // 美加到门送达城市
    // portList:[], // 美加到门卸货港卸货地
    // 美加到门 城市邮编
    async getChakan(){
      let cou_id =  this.mjdmForm.country_id
        let key = this.mjdmForm.end_city_id
        if(this.parMessage.type==1){
            cou_id = this.parMessage.country_id
            key = this.parMessage.end_city_id
        }
      let params = {
        page_no: 1,
        page_size: 0,
        countries_id: cou_id,
        end_city_id: key,
      };
      const res = await getPortByCityId(params);
      if (res.code == 1) {
        this.portList = res.data.lists;
        this.mjdmForm.port_id =  res.data.lists[0].id
        this.chakanShow=false
      }
    },
    async getZipCodeList() {
      this.loading = true;
      let cou_id =  this.mjdmForm.country_id
      let storage = {}
      let key = this.mjdmForm.end_city_id
      if(this.$route.params.country_id!=undefined && this.$route.params.country_id!='' &&  this.$route.params.country_id!=null){
        storage = JSON.parse(sessionStorage.getItem('mjdm'))
        if(storage){
          key = storage.keywordA
      }
      }
      if(this.parMessage.type==1){
            cou_id = this.parMessage.country_id
            key = this.parMessage.end_city_id
        }
      let params = {
        page_no: 1,
        page_size: 10,
        countries_id: cou_id,
        keyword: key,
      };
      try {
        const res = await getCityList(params);
        if (res.code == 1) {
          this.loading = false;
          this.endPortList = res.data.lists;
        }else{
          this.loading = false;
          this.endPortList=[]
        }
      } catch (error) {
        this.loading = false;
        this.endPortList=[]
        console.log(error,'失败');
      }
      
    },
    // 城市邮编 远程搜索
    zipCodeRemoteMethod(query) {
      if (query !== "") {
        setTimeout(() => {
          this.mjdmForm.end_city_id = query
          this.getZipCodeList();
        }, 200);
      } else {
        this.endPortList = [];
      }
    },
    // 获取附近港口
    async getfujinPort() {
        let cou_id =  this.mjdmForm.country_id
        let key = this.mjdmForm.end_city_id
        if(this.parMessage.type==1){
            cou_id = this.parMessage.country_id
            key = this.parMessage.end_city_id
        }
      let params = {
        page_no: 1,
        page_size: 3,
        countries_id: cou_id,
        end_city_id: key,
      };
      const res = await getPortByCityId(params);
      if (res.code == 1) {
        this.portList = res.data.lists;
        this.mjdmForm.port_id =  res.data.lists[0].id
      }else{
        this.portList=[]
      }
    },

    // 获取运价
    async getFreightRates(){
        try {
            const res = await MjdmOnlineInquiryRecordsAdd(this.mjdmForm,this.headers)
            if (res.code==1) {
              this.result = true;

              this.kefuForm = res.data.kefu_info

              this.fee_standards = this.showHtml(res.data.fee_standards);
              this.fee = res.data.price
              // 经纬度
              this.parentObject.state_lon = -75.14461502392527;
              this.parentObject.state_lat = 39.91581782704861;
              this.parentObject.end_lon = -75.1148;
              this.parentObject.end_lat = 40.1238;
              // 子传父 传值
              this.message = {
                parentObject:{
                  state_lon:res.data.state_lon, // 开始地点纬度
                  state_lat:res.data.state_lat,  //开始地点经度
                  end_lon:res.data.end_lon,  //结束地点纬度
                  end_lat:res.data.end_lat,  //结束地点经度
                  select:this.mjdmForm.country_id,  //国家
                },
                distance:res.data.distance,  //距离，单位英里
                state_area_name:res.data.state_area_name,  //开始地点名称
                end_port_name:res.data.end_port_name  //结束地点名称
              }

              let country_name = this.mjdmForm.country_id==6?'USA':'CANADA'
              this.emailForm.email = res.data.kefu_info.address
              this.emailForm.kefu_id = res.data.kefu_info.id
              this.emailForm.mjdmInfo = {
                type:'出口',
                country_name:country_name,
                price:res.data.price,
                distance:res.data.distance,  //距离，单位英里
                state_area_name:res.data.state_area_name,  //开始地点名称
                state_area_code:res.data.state_area_code || 0,
                end_port_name:res.data.end_port_name  //结束地点名称
              }

              this.onlineForm.price = res.data.price
              this.onlineForm.distance = res.data.distance

              this.$emit("from-child", this.message);

              // 下单页面带走的参数
              this.canshu={
                type:'1', // 进出口：1出口、2进口
                country_id : this.mjdmForm.country_id, // 国家id
                // state_port_id : this.mjdmForm.state_port_id, // 起运港ID | 卸货港ID
                end_city_id : this.mjdmForm.end_city_id, // 送达城市ID | 起运城市ID
                port_id : this.mjdmForm.port_id, // 卸货港、卸货地ID | 装货港、装货地ID
                price : res.data.price, // 费用
                country_name : this.mjdmForm.country_id == 6 ? '美国' : '加拿大', // 国家名称
                state_port_name : res.data.state_area_name, // 起运港口名称
                end_place_name : res.data.end_port_name, // 送达地名称
                distance : res.data.distance, // 距离
                kefu_info: res.data.kefu_info
              }
            }
        } catch (error) {
            console.log(error,'失败')
        }
    },
    // 富文本处理
    showHtml(str) {
      return str
        .replace(str ? /&(?!#?\w+;)/g : /&/g, "&amp;")
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'")
        .replace(/&amp;nbsp;/g, "\u3000");
    },
    // 我要下单
    placeAnOrder(){
      let is_authentication= JSON.parse(localStorage.getItem('userInfo')).is_authentication
      if(is_authentication!=2){
        if(is_authentication==0){
            this.$confirm('您还未进行身份认证，请先进行认证', '提示', {confirmButtonText: '去认证',cancelButtonText: '取消',type: 'warning'}).then(async() => {
              this.$router.push({
                name:'UserInfo',
                params:{
                  menuInx: '2'
                }
              })
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消'
              });          
            });
          }else{
            this.$confirm('您的认证还未通过，请等待审核', '提示', {confirmButtonText: '去查看',cancelButtonText: '取消',type: 'warning'}).then(async() => {
              this.$router.push({
                name:'UserInfo',
                params:{
                  menuInx: '2'
                }
              })
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消'
              });          
            });
          }
        
        return
      }
        if(this.is_vip==0){
          this.$message({
            type:'error',
          message:'您还不是会员，请先购买会员'
          })
          return
        }
      sessionStorage.removeItem('mjdm')
      this.$router.push({
        name:'PlaceAnOrder',
        params:this.canshu
      })
    },
    onlineMessage(){
      let e = this.mjdmForm
      console.log('fa',e)
      this.onlineForm.country_id = e.country_id
      this.onlineForm.end_city_id = e.end_city_id
      this.onlineForm.port_id = e.port_id

      this.onlineForm.kefu_id = this.kefuForm.id
      
      this.dialogLiuyan = true
    },
    validFn(email) {
        if(email==''){
            this.$message({
                message: "请输入邮箱地址",
                type: "error",
            });
            return false;
        }
        
        if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email)) {
            this.$message({
                message: "请输入正确的邮箱地址",
                type: "error",
            });
            return false;
        }
        return true;
    },
    async submitMessage(){
        try {
            // 判断验证是否通过
            if (!this.validFn(this.onlineForm.email)) {
                return;
            }

            if (this.isSubmitting) return;  // 防止连点操作  

            this.isSubmitting = true;

            const res = await mjdmReplyAdd(this.onlineForm,this.headers)
            if(res.code==1){
                this.isSubmitting = false;

                this.$message({
                    type:"success",
                    message:'成功'
                })
                this.dialogLiuyan = false
                this.jiehe = 1

                this.onlineForm.content = ''
                
            }else{
                this.isSubmitting = false;

                this.$message({
                    type:"error",
                    message:res.msg
                })
            }
        } catch (error) {
            console.log(error,'error');
        }
    },
    showKefu(){
      this.dialogVisible = true
    },
  },
  mounted(){
    this.getBoxTypeList();
    if(this.$route.params.country_id!=undefined && this.$route.params.country_id!=''){
      if(JSON.parse(sessionStorage.getItem('mjdm'))){
        let storage = JSON.parse(sessionStorage.getItem('mjdm'))
        if (storage.type==1) {
            // type: "1", // 进出口：1出口、2进口
            // country_id: "", // 国家id
            // state_port_id: "", // 起运港ID | 卸货港ID
            // end_city_id: "", // 送达城市ID | 起运城市ID
            // port_id: "", // 卸货港、卸货地ID | 装货港、装货地ID
            // cases_gauge_type_id: "", //箱规ID

            this.mjdmForm.country_id = storage.country_id
            // this.mjdmForm.state_port_id = storage.state_port_id
            this.mjdmForm.end_city_id = storage.end_city_id
            this.mjdmForm.port_id = storage.port_id
            // this.mjdmForm.cases_gauge_type_id = storage.cases_gauge_type_id

            this.getPortList(this.parMessage.country_id)
            this.getZipCodeList()
            this.getfujinPort()

            this.getFreightRates()
        }
      }
    }
    
    if(localStorage.getItem("userInfo")){
          let user = JSON.parse(localStorage.getItem("userInfo"))
          this.onlineForm.email = user.email
          this.onlineForm.nickname = user.nickname
    }
  }
};
</script>
    
<style style lang="scss" scoped>
.delivery-main {
  // width: 1152px;
  // height: 72px;
  background: #f9f9f9;
  border-radius: 8px 8px 8px 8px;
  margin-top: 20px;
  box-sizing: border-box;
  padding: 14px 8px 14px 16px;
  display: flex;
  justify-content: space-between;
  .delivery-main-box {
    border-right: 1px solid #ddd;
    padding-right: 8px;
    height: 48px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 353px;
    img {
      width: 20px;
      height: 20px;
      margin-right: 8px;
    }
    .address {
      width: 336px;
      // div:first-child{
      //   color: #666;
      // }
      div {
        display: block;
        height: 20px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #999999;
        line-height: 16px;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }
      input {
        width: 100%;
        border: none;
        outline: none;
        background: #f9f9f9;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #999999;
        line-height: 16px;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }
      input {
        color: #333;
        margin-top: 4px;
      }
      input::placeholder {
        color: #ccc;
      }
      .el-icon-date:before {
        content: "";
      }
      .el-input {
        display: inline-block;
        width: 80px;
      }
      .el-input--prefix .el-input__inner {
        padding-left: 0;
        padding-right: 0;
        width: 80px;
        height: 20px;
        font-size: 14px;
        display: inline-block;
      }
    }

    // 选择开关
    .switch {
      width: 100px;
      height: 34px;
      background: #ffffff;
      border-radius: 8px 8px 8px 8px;
      box-sizing: border-box;
      padding: 4px;
      display: flex;
      div {
        // width: 43px;
        height: 100%;
        border-radius: 8px 8px 8px 8px;
        color: #999999;
        padding: 3px 7px;
        font-size: 14px;
        box-sizing: border-box;
        &:nth-child(1) {
          margin-right: 4px;
        }
      }
      .switchBackground {
        background: #0073f5;
        color: #ffffff;
      }
    }
  }
  .search {
    width: 52px;
    height: 52px;
    background: #0073f5;
    border-radius: 8px 8px 8px 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    i {
      color: #fff;
      font-size: 20px;
    }
  }

  // 日期选择器
  :deep(.el-date-editor) {
    width: 200px !important;
    border: 0px;
    background: #f9f9f9;
    padding: 0;
    display: flex !important;
    align-items: baseline;
    height: 20px;
    input {
      background: #f9f9f9;
    }
    i.el-input__icon.el-range__icon.null {
      width: 0px;
    }
    .el-date-editor .el-range-separator {
      height: 20px;
    }
  }
}
.delivery-main-1 {
  flex-wrap: wrap;
  padding-bottom: 0;
  .delivery-main-box {
    margin-bottom: 16px;
    &:nth-child(n + 1) {
      // width: 360px;
    }
    // &:nth-child(n + 2) {
    //   margin-left: 8px;
    // }
    &:nth-child(3n) {
      border: 0;
    }
    &:nth-child(4) {
      border-right: 1px solid #ddd;
      margin-left: 0px;
    }
  }
}

.youjiantou {
  position: relative;
  .youbian {
    position: absolute;
    // left: 316px;
    top: 18px;
    right: -18px;
  }
  .youbianvv {
    top: 13px;
  }
}
.el-dropdown {
  position: relative;
  span {
    position: absolute;
    top: -5px;
    right: 20px;
  }
}

.huoquyj {
  width: 100%;
  text-align: right;
  margin-bottom: 12px;
  .el-button {
    width: 120px;
    height: 48px;
    background: #0073f5;
    border-radius: 8px 8px 8px 8px;
    font-size: 16px;
    color: #ffffff;
  }
}

.jieguo {
  // width: 1136px;
  // height: 760px;
  background: #f9f9f9;
  border-radius: 12px 12px 12px 12px;
  margin-top: 17px;
  padding: 32px 32px 19px 32px;
  box-sizing: border-box;

  .tit {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 18px;
    color: #333333;
    font-style: normal;
    text-transform: none;
    margin-bottom: 24px;
  }
  .role {
    // height: 560px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #666666;
    font-style: normal;
    text-transform: none;
  }

  .foot {
    border-top: #ddd 1px solid;
    height: 86px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 32px;
    .heji {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #333333;
      font-style: normal;
      text-transform: none;
      span {
        color: #fe3300;
      }
    }

    .butt {
      .zixun {
        width: 120px;
        height: 48px;
        border-radius: 8px 8px 8px 8px;
        border: 1px solid #D9276D;
        background: #fff;
        font-size: 16px;
        color: #D9276D;
      }
      .xiadan {
        width: 120px;
        height: 48px;
        background: #D9276D;
        border-radius: 8px 8px 8px 8px;
        font-size: 16px;
        color: #ffffff;
        border: 0;
      }
    }
  }
}

.info {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  .map {
    width: 800px;
    height: 480px;
    background: pink;
  }

  .xinxi {
    width: 316px;
    height: 480px;
    background: #f9f9f9;
    border-radius: 0px 0px 0px 0px;
    padding: 20px;
    box-sizing: border-box;

    .tit {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #000000;
      font-style: normal;
      text-transform: none;
      margin-bottom: 24px;
    }

    .comn {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #0073f5;
      font-style: normal;
      text-transform: none;

      span {
        display: inline-block;
        width: 84px;
        height: 20px;
        font-size: 14px;
        color: #333333;
        text-align: right;
        margin-bottom: 12px;
      }
    }
  }
}
:deep(.el-select) {
  input {
    background: #f9f9f9;
    border: 0;
    padding: 0;
  }
}

.chakan{
  margin-left: 20px;
}


.ddDialog{
    :deep(.el-dialog){
        width: 1200px;
        // height: 800px;

        .el-dialog__close{
            font-size: 24px;
            color: #455B73;
        }
    }

    .dd-con{
        margin: 0 34px;
    }

    .dd-con-yi{
        justify-content: space-between;
        margin-bottom: 28px;
        .dd-con-yi-width{
            width: 534px;

            :deep(.el-select){
                input{
                    width: 534px;
                    height: 48px;
                    background: #FFFFFF;
                    border-radius: 2px 2px 2px 2px;
                    border: 1px solid #DADFE9;
                    font-size: 20px;
                    color: #171B47;
                }
            }

            :deep(.el-input){
                input{
                    width: 534px;
                    height: 48px;
                    background: #FFFFFF;
                    border-radius: 2px 2px 2px 2px;
                    border: 1px solid #DADFE9;
                    font-size: 20px;
                    color: #171B47;
                }
            }
        }

        .dd-con-er-width{
          :deep(.el-select){
                input{
                    width: 348px;
                    height: 48px;
                    background: #FFFFFF;
                    border-radius: 2px 2px 2px 2px;
                    border: 1px solid #DADFE9;
                    font-size: 20px;
                    color: #171B47;
                    padding-left: 15px;
                }
            }
        }
    }

    .dd-con-er{
        :deep(.el-textarea) {
            .el-textarea__inner {
                height: 245px;
                background: #FFFFFF;
                border-radius: 2px 2px 2px 2px;
                border: 1px solid #DADFE9;
                font-size: 20px;
                color: #171B47;
            }
        }
    }

    .dd-con-tit{
        font-weight: 400;
        font-size: 18px;
        color: #171B47;
        margin-bottom: 11px;
        span{
            color: #D9276D;
        }
    }

    .dialog-footer{
        text-align: center;

        .quxiao{
            width: 128px;
            height: 52px;
            border-radius: 2px 2px 2px 2px;
            border: 1px solid #A2AFC9;

            font-size: 24px;
            color: #171B47;
        }
        .queding{
            margin-left: 32px;
            width: 128px;
            height: 52px;
            background: #D9276D;
            border-radius: 2px 2px 2px 2px;
            font-size: 24px;
            color: #FFFFFF;
            border: none;
        }
    }
}

.txhz{
  display: flex;
  align-items: center;
}

.appdialog{
    :deep(.el-dialog){
        width: 1100px;
        height: 329px;
        background: #FFFFFF;
        .el-dialog__header,.el-dialog__body{
            padding: 0;
        }

        .applan{
            height: 10px;
            background: #2A1D62;

            .appfen{
                width: 138px;
                height: 10px;
                background: #0073f5;
            }
        }

        .dingwei{
            position: relative;
        }

        .dhk-xia{
            display: flex;
            align-items: center;
            height: 217px;
            padding: 0 42px;
            box-sizing: border-box;
        }

        .dizhi{
            height: 102px;
            background: #F8F8F8;

            display: flex;
            align-items: center;
            padding-left: 45px;
            .kflogoIng{
                // width: 58px;
                height: 58px;
                margin-right: 15px;
            }

            .dx-tit{
                font-family: DSemiBold;
                font-weight: 600;
                font-size: 22px;
                color: #2A1D62;
                margin-bottom: 10px;
            }

            .dz-wprd{
                font-family: DMedium;
                font-weight: 500;
                font-size: 16px;
                color: #3B3169;

                span{
                    color: #E15B90;
                }
            }
        }
       
        .el-icon-close{
            font-size: 24px;
            color: #2A1D62;
            cursor: pointer;

            position: absolute;
            top: 20px;
            right: 24px;
        }

        .txDingwei{
            position: relative;
            width: 120px;
            height: 100%;
            margin-right: 36px;
            .zanwu{
              text-align: center;
              width: 100%;
              height: 140px;
              border: 1px solid #ccc;
              line-height: 140px;
              color: #666;
            }
            .delImg{
                position: absolute;
                right: 6px;
                bottom: 10px;
                width: 24px;
                height: 24px;
                cursor: pointer;
            }
        }
            
        .touxImg{
            width: 120px;
            object-fit: cover;
            max-height: 200px;
            // height: 146px;
            // height: 100%;
        }

        .xia-left{
            display: flex;
            color: #16103D;
            .kfdzimg{
                width: 38px;
                height: 38px;
            }

            .txname{
                font-family: PMedium;
                color: #16103D;
                font-size: 28px;
            }

            .neior{
                margin-top: 12px;
                margin-bottom: 15px;
                width: 262px;
                height: 46px;

                background-image:url('@/assets/home/dingweiBj.png');	
                background-repeat: no-repeat;
                background-size:100% 100%;

                font-weight: 500;
                font-size: 13px;
                color: #2A1D62;
                font-family: PMedium;
                padding-left: 10px;
                padding-right: 40px;
                padding-top: 8px;
                box-sizing: border-box;
            }

            .wangzhi{
                font-weight: 400;
                font-size: 18px;
                color: #D9276D;
                display: flex;
                align-items: center;
                .img{
                    width: 28px;
                    height: 28px;
                    margin-right: 4px;
                }
                a{
                    color: #D9276D;
                }
            }
        }

        .xia-line{
            margin-left: 22px;
            margin-right: 22px;
            height: 138px;
            border: 1px solid #DCDDEA;
        }

        .xia-right{
            .tx-xx{
                margin-bottom: 17px;
                font-weight: 400;
                font-size: 18px;
                color: #171B47;
                display: flex;
                align-items: center;
                .tx-img{
                    width: 24px;
                    height: 24px;
                    margin-right: 16px;
                }

                .span{
                    font-size: 16px;
                    color: #787DAA;
                }

                
                .el-button{
                  color: #D9276D;
                  margin-left: 4px;
                }

                .copyimg{
                    cursor: pointer;
                    width: 20px;
                    height: 20px;
                    margin-left: 4px;
                }
            }

            
            .clickImg{
              width: 24px;
              height: 24px;
              margin-left: 4px;
            }

            .youxiang{
              cursor: pointer;
            }
        }
    }
}

.emailDialog{
    :deep(.el-dialog){
        width: 1200px;
        // height: 790px;

        .el-dialog__close{
            font-size: 24px;
            color: #455B73;
        }
    }

    .dd-con{
        margin: 0 34px;
    }

    .dd-con-yi{
        margin-bottom: 28px;

        :deep(.el-input){
            input{
                height: 48px;
                background: #FFFFFF;
                border-radius: 2px 2px 2px 2px;
                border: 1px solid #DADFE9;
                font-size: 20px;
                color: #171B47;
            }
        }
    }

    .dd-con-er{
        :deep(.el-textarea) {
            .el-textarea__inner {
                height: 245px;
                background: #FFFFFF;
                border-radius: 2px 2px 2px 2px;
                border: 1px solid #DADFE9;
                font-size: 20px;
                color: #171B47;
            }
        }
    }

    .dd-con-tit{
        font-weight: 400;
        font-size: 18px;
        color: #171B47;
        margin-bottom: 11px;
        span{
            color: #D9276D;
        }
    }

    .dialog-footer{
        text-align: center;
        margin-top: 24px;
        .quxiao{
            width: 128px;
            height: 52px;
            border-radius: 2px 2px 2px 2px;
            border: 1px solid #A2AFC9;

            font-size: 24px;
            color: #171B47;
        }
        .queding{
            margin-left: 32px;
            height: 52px;
            width: 128px;
            background: #D9276D;
            border-radius: 2px 2px 2px 2px;
            font-size: 24px;
            color: #FFFFFF;
            border: none;
        }
    }
}

.el-tag{
    margin-right: 12px;
    margin-bottom: 12px;
    font-size: 16px;
    height: 100%;
    padding: 4px 12px;
}

.button-new-tag{
    font-size: 16px;
}
</style>